module.exports = __webpack_public_path__ + "static/media/IMG-3.b138dd5c.jpg";